import "./personList.css";
import Person from './person';


function PersonList({ persons}) {
  return (
    <div>
      {persons.map((person) => (
        <Person person={person}/>
      ))}
    </div>
  );
}

export default PersonList;
